import { types } from "@gadgetinc/mobx-quick-tree";

export const DevelopmentEnvironmentName = "Development" as const;
export const ProductionEnvironmentName = "Production" as const;
export const EnvironmentNames = [DevelopmentEnvironmentName, ProductionEnvironmentName] as const;
export const isEnvironmentName = (environmentName: string): environmentName is EnvironmentName =>
  (EnvironmentNames as readonly string[]).includes(environmentName);
export type EnvironmentName = (typeof EnvironmentNames)[number];

export const EnvironmentNameMSTType = types.optional(types.frozen<EnvironmentName>(), DevelopmentEnvironmentName);
